export default "__VITE_ASSET__2031702d__"